import React, { useState, useEffect } from 'react';
import styles from '../static/styles/CompletedTasks.module.css';
import ArrowLeft from '../static/img/backArrow.png'
import { useNavigate } from 'react-router-dom';

import firstTaskBG from '../static/img/DailyTasks/iconCompletedBG.svg';
import dummyImg from '../static/img/DailyCheckin/iconDailyTaskDummy.png';
import { fetchCompletedTasks } from '../api/challenges';

const CompletedTasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [gameName, setGameName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {

    document.title = 'Completed Tasks | Jazz Esl';

    const fetchTasks = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetchCompletedTasks();
        // console.log('API Response:', response);

        if (response && response.data) {
          const completedTasks = response.data.map((challenge, index) => ({
            id: challenge.challenge_uuid || index + 1,
            title: challenge.challenge_name || 'Challenge',
            reward: `Win ${challenge.prize || '0'} Credits`,
            image: challenge.thumbnail || dummyImg,
            claimed: true,
          }));
          setTasks(completedTasks);
        } else {
          setTasks([]);
        }
      } catch (err) {
        setError('Error loading tasks');
        setTasks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, []);

  const gradients = [
    "linear-gradient(135deg, #1A0A3D, #080014)",
    "linear-gradient(135deg, #3D0A14, #1A0005)",
    "linear-gradient(135deg, #1A3D0A, #0A1A00)",
    "linear-gradient(135deg, #280A3D, #0C001A)",
  ];

  return (
    <div className={styles.container}>
      <div className={styles.navigationHeader}>
        <div
          className={styles.navigationBack}
          onClick={() => navigate(-1)}
        >
          <img src={ArrowLeft} alt="<" />
        </div>
        <div className={styles.navigationTitle}>
          <p>ESL</p>
          <h2 className={styles.heading}>Completed Tasks</h2>
        </div>
      </div>
      <div className={styles.gamingTaskHeader}>
        <p className={styles.subheading}>ESL</p>
        <h2 className={styles.heading}>Completed Tasks</h2>
        <div className={styles.headerstatsContainer}>
          <div className={styles.headerstats}>
            <span>{tasks.length}</span>
            <p>completed tasks</p>
          </div>
        </div>
      </div>

      {loading && <div className={styles.loading}>Loading tasks...</div>}
      {error && <div className={styles.error}>Error</div>}

      <div className={styles.tasksContainer}>
        {tasks.length > 0 ? (
          tasks.map((task, index) => (
            <div
              key={task.id}
              className={styles.taskCard}
              style={{
                "--bg": gradients[index % gradients.length],
              }}>
              <div className={styles.taskText}>
                <p className={styles.taskTitle}>{task.title}</p>
                <p className={styles.taskReward}>{task.reward}</p>
              </div>
              <img
                src={task.image}
                alt={`Task ${index + 1}`}
                className={styles.taskImage}
              />
              <div className={styles.claimed}>CLAIMED</div>
            </div>
          ))
        ) : !loading && !error && (
          <div className={styles.noTasks}>No completed tasks available</div>
        )}
      </div>
    </div>
  );
};

export default CompletedTasks;